import { observer } from 'mobx-react-lite';
import numeral from 'numeral';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { Importer } from '@feathr/blackbox';
import { Text } from '@feathr/components';

import { getRejectionLines, hasRunFinished } from './ImportRunDetails.utils';

interface IRejectionBreakdownProps {
  importer: Importer;
}

/** One line per reason the run refused rows, with the server's sentence for each. */
function RejectionBreakdown({ importer }: Readonly<IRejectionBreakdownProps>): JSX.Element | null {
  const { t } = useTranslation();

  const lines = hasRunFinished(importer) ? getRejectionLines(importer) : [];
  if (!lines.length) {
    return null;
  }

  // Placeholder copy, pending Product and Design.
  return (
    <>
      {lines.map(({ code, count, message }) => {
        const formattedCount = numeral(count).format('0,0');
        return (
          <Text.DefaultRegular key={code}>
            {message
              ? t('{{formattedCount}} rows: {{- message}}', { count, formattedCount, message })
              : t('{{formattedCount}} rows were not imported.', { count, formattedCount })}
          </Text.DefaultRegular>
        );
      })}
    </>
  );
}

export default observer(RejectionBreakdown);
